import { Injectable, inject } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { DownloadListDialogComponent, DownloadListDialogResult } from './download-list-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DownloadListService {
  private dialog = inject(Dialog);

  openDownloadListDialog() {
    const isMobile = window.innerWidth <= 768;

    this.dialog.open<DownloadListDialogResult>(DownloadListDialogComponent, {
      width: isMobile ? '100vw' : undefined,
      maxWidth: isMobile ? '100vw' : '800px',
      minWidth: isMobile ? '100vw' : '720px',
      height: isMobile ? '100vh' : undefined,
      panelClass: isMobile ? 'download-list-dialog-mobile' : undefined,
    });
  }
}
